import { render, staticRenderFns } from "./ConvoComments.vue?vue&type=template&id=f314a81e&"
import script from "./ConvoComments.vue?vue&type=script&lang=js&"
export * from "./ConvoComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports